import React from "react"

function Dashboard(){
    return (
        <div>
            <h1> Welcome!!!Your Consultations </h1>
        </div>   
    )
}
export default Dashboard